import { useSimpleGroupingTask } from 'features/simple-grouping/use-simple-grouping-task'
import { GroupWorkView } from './presentation/group-work-view'

/**
 * Group work, with the task `SIMPLE_GROUPING_STATE_CHANGED` carries. Each part
 * renders only when present - group work without a task gets the heading and
 * the hint.
 */
export const ConfiguredGroupWork = (): JSX.Element => {
	const task = useSimpleGroupingTask()
	return <GroupWorkView name={task?.name} description={task?.description} />
}

export default ConfiguredGroupWork
